var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-container",
        [
          _c(
            "el-header",
            { attrs: { height: "42px" } },
            [
              _vm.viewMode == "list"
                ? _c("span", { staticClass: "ik-list-title" }, [
                    _c(
                      "span",
                      { staticClass: "svg-container ik-list-icon" },
                      [_c("svg-icon", { attrs: { "icon-class": "database" } })],
                      1
                    ),
                    _c("span", [_vm._v("数据列表")]),
                  ])
                : _vm._e(),
              _vm.viewMode === "list"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDiySaveBtn },
                        },
                        [_vm._v("新增")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDiyUpdateBtn },
                        },
                        [_vm._v("修改")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.listDeleteBtn },
                        },
                        [_vm._v("删除")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.viewMode === "info"
                ? _c(
                    "el-button-group",
                    { staticClass: "ik-list-menu" },
                    [
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCreateBtn },
                            },
                            [_vm._v("新增")]
                          )
                        : _vm._e(),
                      _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoUpdateBtn },
                            },
                            [_vm._v("修改")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit" || _vm.mode == "details"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoCopyBtn },
                            },
                            [_vm._v("复制")]
                          )
                        : _vm._e(),
                      _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoDetailsBtn },
                            },
                            [_vm._v("详情")]
                          )
                        : _vm._e(),
                      _vm.mode == "add" || _vm.mode == "edit"
                        ? _c(
                            "el-button",
                            {
                              staticClass: "ik-list-menu-btn",
                              attrs: { size: "medium" },
                              on: { click: _vm.infoSaveBtn },
                            },
                            [_vm._v("保存")]
                          )
                        : _vm._e(),
                      _c(
                        "el-button",
                        {
                          staticClass: "ik-list-menu-btn",
                          attrs: { size: "medium" },
                          on: { click: _vm.infoCancelBtn },
                        },
                        [_vm._v("取消")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-main",
            [
              _vm.viewMode == "info"
                ? _c(
                    "el-form",
                    {
                      staticClass: "ik-info-head",
                      attrs: {
                        id: "ik-info-head",
                        inline: true,
                        "label-width": "120px",
                        disabled: _vm.mode == "details",
                      },
                      on: { validate: _vm.validate },
                      model: {
                        value: _vm.data.head,
                        callback: function ($$v) {
                          _vm.$set(_vm.data, "head", $$v)
                        },
                        expression: "data.head",
                      },
                    },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_id",
                                attrs: {
                                  code: "id",
                                  name: "ID",
                                  "default-value": 0,
                                  disabled: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["id"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "id", $$v)
                                  },
                                  expression: "data.head['id']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_chainDictionaryId",
                                attrs: {
                                  code: "chainDictionaryId",
                                  name: "供应链词典ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["chainDictionaryId"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "chainDictionaryId",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['chainDictionaryId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_chainDictionaryCode",
                                attrs: {
                                  url: "base/dictionary/medicinedic/chaindictionary/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "chainDictionaryCode",
                                  name: "供应链词典编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onPopupClick: _vm.headPopupClick,
                                  onFieldChange: _vm.onFieldChange,
                                },
                                model: {
                                  value: _vm.data.head["chainDictionaryCode"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "chainDictionaryCode",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['chainDictionaryCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_chainDictionaryName",
                                attrs: {
                                  code: "chainDictionaryName",
                                  name: "供应链词典名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["chainDictionaryName"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "chainDictionaryName",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "data.head['chainDictionaryName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-id", {
                                ref: "input_storeId",
                                attrs: {
                                  code: "storeId",
                                  name: "门店ID",
                                  "default-value": 0,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeId"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeId", $$v)
                                  },
                                  expression: "data.head['storeId']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-data-popup", {
                                ref: "input_storeCode",
                                attrs: {
                                  url: "base/user/user/store/find/findPagination",
                                  "filed-list": [
                                    { code: "code", name: "编码" },
                                    { code: "name", name: "名称" },
                                  ],
                                  "search-key": "name",
                                  searcher: {},
                                  code: "storeCode",
                                  name: "门店编码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: {
                                  onFieldChange: _vm.onFieldChange,
                                  onPopupClick: _vm.headPopupClick,
                                },
                                model: {
                                  value: _vm.data.head["storeCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeCode", $$v)
                                  },
                                  expression: "data.head['storeCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_storeName",
                                attrs: {
                                  code: "storeName",
                                  name: "门店名称",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["storeName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "storeName", $$v)
                                  },
                                  expression: "data.head['storeName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_contactName",
                                attrs: {
                                  code: "contactName",
                                  name: "联系人",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["contactName"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "contactName", $$v)
                                  },
                                  expression: "data.head['contactName']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_contactPhone",
                                attrs: {
                                  code: "contactPhone",
                                  name: "联系电话",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["contactPhone"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "contactPhone", $$v)
                                  },
                                  expression: "data.head['contactPhone']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_contactEmail",
                                attrs: {
                                  code: "contactEmail",
                                  name: "联系邮箱",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["contactEmail"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "contactEmail", $$v)
                                  },
                                  expression: "data.head['contactEmail']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_contactAddress",
                                attrs: {
                                  code: "contactAddress",
                                  name: "联系地址",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["contactAddress"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "contactAddress",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['contactAddress']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_chainDescribe",
                                attrs: {
                                  code: "chainDescribe",
                                  name: "描述",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["chainDescribe"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "chainDescribe",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['chainDescribe']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-number", {
                                ref: "input_dicWeight",
                                attrs: {
                                  code: "dicWeight",
                                  name: "词典权重",
                                  "default-value": 0,
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["dicWeight"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "dicWeight", $$v)
                                  },
                                  expression: "data.head['dicWeight']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-text", {
                                ref: "input_pinyinCode",
                                attrs: {
                                  code: "pinyinCode",
                                  name: "拼音码",
                                  "default-value": "",
                                  "min-length": 0,
                                  "max-length": 20,
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["pinyinCode"],
                                  callback: function ($$v) {
                                    _vm.$set(_vm.data.head, "pinyinCode", $$v)
                                  },
                                  expression: "data.head['pinyinCode']",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("ik-form-select", {
                                ref: "input_effectiveSign",
                                attrs: {
                                  code: "effectiveSign",
                                  name: "有效标识",
                                  "default-value": "",
                                  "key-field": "key",
                                  "value-field": "value",
                                  options: _vm.toJson(
                                    _vm.jsonStr.effectiveSign
                                  ),
                                  disabled: false,
                                  require: true,
                                },
                                on: { onFieldChange: _vm.onFieldChange },
                                model: {
                                  value: _vm.data.head["effectiveSign"],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.data.head,
                                      "effectiveSign",
                                      $$v
                                    )
                                  },
                                  expression: "data.head['effectiveSign']",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "querybg" },
                [
                  _vm.viewMode == "list"
                    ? _c(
                        "el-collapse",
                        {
                          staticClass: "ik-list-searcher",
                          attrs: { accordion: "" },
                          model: {
                            value: _vm.searcherActive,
                            callback: function ($$v) {
                              _vm.searcherActive = $$v
                            },
                            expression: "searcherActive",
                          },
                        },
                        [
                          _c(
                            "el-collapse-item",
                            {
                              staticClass: "ik-list-searcher-item",
                              attrs: { title: "", name: "1" },
                            },
                            [
                              _c("template", { slot: "title" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "ik-list-searcher-item-titles",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "svg-container ik-list-icon",
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: { "icon-class": "search" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" 查询条件 "),
                                  ]
                                ),
                              ]),
                              _c(
                                "el-form",
                                {
                                  staticClass: "ik-info-head",
                                  attrs: {
                                    id: "ik-info-head",
                                    inline: true,
                                    "label-width": "120px",
                                    disabled: false,
                                  },
                                  model: {
                                    value: _vm.searcher,
                                    callback: function ($$v) {
                                      _vm.searcher = $$v
                                    },
                                    expression: "searcher",
                                  },
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_pinyinCode",
                                            attrs: {
                                              code: "pinyinCode",
                                              name: "拼音码",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value: _vm.searcher["pinyinCode"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "pinyinCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['pinyinCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-select", {
                                            ref: "input_effectiveSign",
                                            attrs: {
                                              code: "effectiveSign",
                                              name: "有效标识",
                                              "default-value": "",
                                              "key-field": "key",
                                              "value-field": "value",
                                              options: _vm.toJson(
                                                _vm.jsonStr.effectiveSign
                                              ),
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher["effectiveSign"],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "effectiveSign",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['effectiveSign']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_chainDirectoryCode",
                                            attrs: {
                                              code: "chainDirectoryCode",
                                              name: "供应链目录编码",
                                              url: "base/dictionary/medicinedic/chaindirectory/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "chainDirectoryCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "chainDirectoryCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['chainDirectoryCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-data-popup", {
                                            ref: "input_chainDictionaryCode",
                                            attrs: {
                                              code: "chainDictionaryCode",
                                              name: "供应链词典编码",
                                              url: "base/dictionary/medicinedic/chaindictionary/find/findPagination",
                                              "filed-list": [
                                                { code: "code", name: "编码" },
                                                { code: "name", name: "名称" },
                                              ],
                                              "search-key": "name",
                                              searcher: {},
                                              "default-value": "",
                                              disabled: false,
                                            },
                                            on: {
                                              onPopupClick:
                                                _vm.searchPopupClick,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "chainDictionaryCode"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "chainDictionaryCode",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['chainDictionaryCode']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c("ik-form-text", {
                                            ref: "input_chainDictionaryName",
                                            attrs: {
                                              code: "chainDictionaryName",
                                              name: "供应链词典名称",
                                              "default-value": "",
                                              "min-length": 0,
                                              "max-length": 20,
                                              disabled: false,
                                            },
                                            model: {
                                              value:
                                                _vm.searcher[
                                                  "chainDictionaryName"
                                                ],
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.searcher,
                                                  "chainDictionaryName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "searcher['chainDictionaryName']",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "query-class" }, [
                                _c(
                                  "div",
                                  { staticClass: "query-btn-warp" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.searchBtn },
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: { click: _vm.resetBtn },
                                      },
                                      [_vm._v("重置")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                            ],
                            2
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.viewMode == "list"
                ? _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      ref: "table",
                      staticClass: "ik-list-table",
                      attrs: {
                        data: _vm.tableData,
                        "element-loading-text": "加载中...",
                        stripe: true,
                        border: true,
                        fit: true,
                        height: "calc(100% - 50px)",
                        "header-row-class-name": "ik-list-table-header-row",
                        "header-cell-class-name": "ik-list-table-header-cell",
                        "row-class-name": "ik-list-table-body-row",
                        "cell-class-name": "ik-list-table-body-cell",
                        "highlight-current-row": true,
                      },
                      on: { "row-click": _vm.rowClick },
                    },
                    [
                      _c("ik-column-id", {
                        attrs: { code: "id", name: "ID", edit: false },
                      }),
                      _c("ik-column-id", {
                        attrs: {
                          code: "chainDictionaryId",
                          name: "供应链词典ID",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chainDictionaryCode",
                          name: "供应链词典编码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chainDictionaryName",
                          name: "供应链词典名称",
                          edit: false,
                        },
                      }),
                      _c("ik-column-id", {
                        attrs: { code: "storeId", name: "门店ID", edit: false },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "contactName",
                          name: "联系人",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "contactPhone",
                          name: "联系电话",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "contactEmail",
                          name: "联系邮箱",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "contactAddress",
                          name: "联系地址",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "chainDescribe",
                          name: "描述",
                          edit: false,
                        },
                      }),
                      _c("ik-column-number", {
                        attrs: {
                          code: "dicWeight",
                          name: "词典权重",
                          edit: false,
                        },
                      }),
                      _c("ik-column-text", {
                        attrs: {
                          code: "pinyinCode",
                          name: "拼音码",
                          edit: false,
                        },
                      }),
                      _c("ik-column-select", {
                        attrs: {
                          code: "effectiveSign",
                          name: "有效标识",
                          "key-field": "key",
                          "value-field": "value",
                          options: _vm.toJson(_vm.jsonStr.effectiveSign),
                          edit: false,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-footer",
            { attrs: { height: "40px" } },
            [
              _vm.viewMode == "list"
                ? _c("ik-pagination", {
                    ref: "ik_list_pagination",
                    attrs: {
                      "page-no": _vm.pagination.pageNo,
                      "page-size": _vm.pagination.pageSize,
                      "total-count": _vm.pagination.totalCount,
                    },
                    on: { pageChangeMethod: _vm.pageChange },
                  })
                : _c(
                    "el-row",
                    { staticClass: "ik-list-pagination", attrs: { gutter: 0 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticClass: "ik-list-enterprise-info",
                          attrs: { span: 6, offset: 12 },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(" 导萃门诊管理系统 "),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "供应链信息",
            visible: _vm.dialogVisible,
            width: "800px",
            top: "16vh",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { width: "100%" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "enroll-dialog-form",
                  attrs: {
                    id: "enroll-dialog-form",
                    inline: true,
                    "label-width": "80px",
                    disabled: false,
                  },
                  model: {
                    value: _vm.data.head,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "head", $$v)
                    },
                    expression: "data.head",
                  },
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-id", {
                            ref: "dig_input_id",
                            attrs: {
                              code: "id",
                              name: "ID",
                              "default-value": 0,
                              disabled: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["id"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "id", $$v)
                              },
                              expression: "data.head['id']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-data-popup", {
                            ref: "dig_input_chainDirectoryCode",
                            attrs: {
                              code: "chainDirectoryCode",
                              name: "目录编码",
                              url: "base/dictionary/medicinedic/chaindirectory/find/findPagination",
                              "filed-list": [
                                { code: "code", name: "编码" },
                                { code: "name", name: "名称" },
                              ],
                              "search-key": "name",
                              searcher: {},
                              "default-value": "",
                              disabled: _vm.data.head["id"] !== 0,
                              require: true,
                            },
                            on: {
                              onFieldChange: _vm.onFieldChange,
                              onPopupClick: _vm.headPopupClick,
                            },
                            model: {
                              value: _vm.data.head["chainDirectoryCode"],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data.head,
                                  "chainDirectoryCode",
                                  $$v
                                )
                              },
                              expression: "data.head['chainDirectoryCode']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_chainDirectoryCode",
                            attrs: {
                              code: "chainDirectoryName",
                              name: "目录名称",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: true,
                              require: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["chainDirectoryName"],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data.head,
                                  "chainDirectoryName",
                                  $$v
                                )
                              },
                              expression: "data.head['chainDirectoryName']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_chainDictionaryName",
                            attrs: {
                              code: "chainDictionaryName",
                              name: "名称",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: _vm.data.head["id"] !== 0,
                              require: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["chainDictionaryName"],
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.data.head,
                                  "chainDictionaryName",
                                  $$v
                                )
                              },
                              expression: "data.head['chainDictionaryName']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_contactName",
                            attrs: {
                              code: "contactName",
                              name: "联系人",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: false,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["contactName"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "contactName", $$v)
                              },
                              expression: "data.head['contactName']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_contactPhone",
                            attrs: {
                              code: "contactPhone",
                              name: "联系电话",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: false,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head.contactPhone,
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "contactPhone", $$v)
                              },
                              expression: "data.head.contactPhone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_contactEmail",
                            attrs: {
                              code: "contactEmail",
                              name: "联系邮箱",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 50,
                              disabled: false,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["contactEmail"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "contactEmail", $$v)
                              },
                              expression: "data.head['contactEmail']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("ik-form-text", {
                            ref: "dig_input_contactAddress",
                            attrs: {
                              code: "contactAddress",
                              name: "联系地址",
                              "default-value": "",
                              "min-length": 0,
                              "max-length": 2000,
                              disabled: false,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["contactAddress"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "contactAddress", $$v)
                              },
                              expression: "data.head['contactAddress']",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("ik-form-select", {
                            ref: "dig_input_effectiveSign",
                            attrs: {
                              code: "effectiveSign",
                              name: "有效标识",
                              "default-value": "",
                              "key-field": "key",
                              "value-field": "value",
                              options: _vm.toJson(_vm.jsonStr.effectiveSign),
                              disabled: false,
                              require: true,
                            },
                            on: { onFieldChange: _vm.onFieldChange },
                            model: {
                              value: _vm.data.head["effectiveSign"],
                              callback: function ($$v) {
                                _vm.$set(_vm.data.head, "effectiveSign", $$v)
                              },
                              expression: "data.head['effectiveSign']",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.saveOrUpdateInfo },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }